<header class="header"
        *ngIf="data">
  <h1 class="header__title">{{data.title}}</h1>
  <p class="header__subtitle"
     [innerHTML]="data.subtitle | safePureHtml"></p>
</header>
